// @flow
import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from "react-router";
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {withStyles, withTheme} from '@material-ui/core/styles';
import styles from './Pagination.styles.js';

type Props = {
  classes: any,
  totalItems: number,
  match: any,
  perPage: number,
  urlTemplate: any
}

type State = {
  pages: Array<any>,
  total?: number,
  current: number,
  start: number,
  end: number,
  firstDisabled: boolean,
  lastDisabled: boolean,
  nextLink: number | '#',
  lastLink: number | '#',
  prevLink: number | '#',
  firstLink: number | '#'
}

class Pagination extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      pages: [],
      current: 1,
      start: 1,
      end: 1,
      firstDisabled: true,
      lastDisabled: true,
      nextLink: '#',
      lastLink: '#',
      prevLink: '#',
      firstLink: '#',
    };
  }

  setCurrentPage = () => {
    this.setState({
      current: Number(this.props.match.params.page) || 1
    })
  }

  pages = () => {
    // console.log(this.props);
    let pages = [];
    // const totalPages = Math.ceil(this.props.total / this.props.count);
    const current = this.state.current;
    // @TODO: use better solution
    const pnp = window.screen.width > 600 ? 10 : 5; // maximum page numbers per page
    const pnpMaxOneSide = Math.ceil(pnp / 2); // maximum page numbers per page (each side)
    const start = (current <= pnpMaxOneSide) ? 1 : current - pnpMaxOneSide;
    let end = (current <= pnpMaxOneSide) ? pnp : current + pnpMaxOneSide;
    const total = Math.ceil(Number(this.props.totalItems) / Number(this.props.perPage));
    end = (end > total) ? total : end;
    for (let i = start; i <= end; i++) {
      pages = [...pages, {num: i}];
    }

    const firstDisabled = current === 1;
    const lastDisabled = current === total;

    const nextLink = lastDisabled ? '#' : this.makeLink(current + 1);
    const lastLink = lastDisabled ? '#' : this.makeLink(total);

    const prevNum = current - 1;
    const prevLink = firstDisabled ? '#' : this.makeLink(prevNum < 0 ? 1 : prevNum);
    const firstLink = firstDisabled ? '#' : this.makeLink(1);

    this.setState({
      start,
      end,
      total,
      firstDisabled,
      lastDisabled,
      nextLink,
      lastLink,
      prevLink,
      firstLink,
      pages,
    });
  }

  makeLink = (page) => {
    // let url = this.props.match.path;
    let url = this.props.urlTemplate;
    const pageParams = this.props.match.params;
    for (let key in pageParams) {
      const pattern = `:${key}`;
      const value = key === 'page' ? (page || 1) : pageParams[key];
      url = url.replace(pattern, value);
    }
    const pattern = `:page`;
    const value = (page || 1);
    url = url.replace(pattern, value);
    return url;
  }

  componentDidMount() {
    this.setCurrentPage();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.page !== this.props.match.params.page) {
      this.setCurrentPage();
    }

    if (
      (this.props.totalItems && prevProps.totalItems !== this.props.totalItems) || 
      (prevState.current !== this.state.current)
      ) {
      this.pages();
    }
  }

  render() {
    const {classes} = this.props;
    return (
      <ul role="navigation" arialabel="Pagination" className={classes.root}>

        <li
          className={classNames(classes.item, {[classes.disabled]: this.state.firstDisabled})}
        >
        {this.state.firstDisabled && <span>شروع</span>}
        {!this.state.firstDisabled && 
          <Link to={this.state.firstLink}> شروع </Link>
        }
        </li>

        <li
          className={classNames(classes.item, {[classes.disabled]: this.state.firstDisabled})}
        >
          {this.state.firstDisabled && <span>قبلی</span>}
          {!this.state.firstDisabled &&
              <Link to={this.state.prevLink}> قبلی </Link>
          }
        </li>

        {this.state.pages && this.state.pages.map((item, index) => {
          const isCurrent = item.num === this.state.current;
          return (
            <li
              key={item.num}
              className={classNames(classes.item, {[classes.current]: isCurrent})}
            >
              <Link
                to={this.makeLink(item.num)}
              >
                {item.num}
              </Link>
            </li>
          );
        })
        }

        <li className={classNames(classes.item, {[classes.disabled]: this.state.lastDisabled})}>
          {this.state.lastDisabled && <span>بعدی</span>}
          {!this.state.lastDisabled &&
            <Link to={this.state.nextLink}> بعدی </Link>
          }
        </li>


        <li className={classNames(classes.item, {[classes.disabled]: this.state.lastDisabled})}>
          {this.state.lastDisabled && <span>انتها</span>}
          {!this.state.lastDisabled &&
            <Link to={this.state.lastLink}> انتها </Link>
          }
        </li>
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  category: state.navigation.category.id
});

const StyledComponent = withStyles(styles)(withTheme()(Pagination));
const Component = withRouter(connect(mapStateToProps)(StyledComponent));
export {Component as Pagination};
export default Component;